(function () {
    "use strict";
    
    /**
     * Registers an interceptor which detects expired sessions.
     * When this happens, redirect to the login page
     */
    angular.module('app').factory('sessionWatcher', SessionWatcherInterceptor);

    SessionWatcherInterceptor.$inject = ['$rootScope', '$window', '$q'];
    function SessionWatcherInterceptor($rootScope, $window, $q) {
        const httpGoneStatusCode = 410;

        return {
            responseError: responseError
        };

        function responseError(rejection) {
            // Shared WebAPI
            // The session expired errors are handled in such a way that they get a status code 410.
            // We (mis)appropriate the Gone status code to handle session expired errors.
            
            if (isSessionExpired(rejection)) {
                logoff();
                return rejection;
            } else {
                // Return rejected promise to ensure that the errorCallback is triggered
                return $q.reject(rejection);
            }
        }

        /**
         * The original check to determine whether the session is expired
         * @param {Object} rejection the HttpResponse object
         */
        function isSessionExpired(rejection) {
            if (rejection.status === httpGoneStatusCode)
                return true;

            if (!$rootScope || !$rootScope.sessionTimeoutError)
                return false;

            return rejection.data === null || rejection.status === -1 || rejection.data.Message === $rootScope.sessionTimeoutError;
        }

        function logoff() {
            localStorage.clear();

            $window.location = $rootScope.applicationPath + 'Account/Logoff';
        }
    }
})();